<app-loadable-content [loadingController]="locationLoadingController" (onRetry)="loadLocation()">
    <app-title>{{ headerText }}</app-title>
</app-loadable-content>
